import { Stack } from '@mui/material';
import { RiCheckLine } from '@remixicon/react';
import { RemixIcon } from '@upheal/design-system/components/Icon/RemixIcon';
import { Typography } from '@upheal/design-system/components/Typography/Typography';

const ENTERPRISE_FEATURES = [
    'Open API access',
    'Customized note development',
    'Dedicated customer success manager',
    'Service-level agreement (SLA) available',
    'Volume discounts',
    'Single sign-on (SSO)',
] as const;

export const EnterpriseFeatures = () => (
    <>
        {ENTERPRISE_FEATURES.map((feature) => (
            <Stack key={feature} direction="row" gap={1.25} alignItems="center">
                <RemixIcon
                    icon={RiCheckLine}
                    size="sm"
                    color="ds.fg.neutral.primary"
                />
                <Typography variant="sm" fontWeight="bold">
                    {feature}
                </Typography>
            </Stack>
        ))}
    </>
);
